import { render } from "./ReportPaidPoints.vue?vue&type=template&id=926ede98&scoped=true&ts=true"
import script from "./ReportPaidPoints.vue?vue&type=script&lang=ts"
export * from "./ReportPaidPoints.vue?vue&type=script&lang=ts"

import "./ReportPaidPoints.vue?vue&type=style&index=0&id=926ede98&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-926ede98"]])

export default __exports__